import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {provideAnimations} from '@angular/platform-browser/animations';
import {CoreModule} from '~local/app/core/core.module';
import {TranslateModule} from '@ngx-translate/core';
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {provideUserIdleConfig} from 'angular-user-idle';
import {Angulartics2Module} from 'angulartics2';
import {ClipboardModule} from 'ngx-clipboard';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {environment} from '~local/environments/environment';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {routes} from '~local/app/app-routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        provideAnimations(),
        importProvidersFrom([
            NgxDaterangepickerMd.forRoot(),
            TranslateModule.forRoot(),
            MatMomentDateModule,
            CoreModule,
            ClipboardModule,
            SweetAlert2Module.forRoot(),
            Angulartics2Module.forRoot(),
        ]),
        provideUserIdleConfig(environment.userIdleConfig),

    ]
};
